import { GET_ASSOCIATED_APPROVERS, GET_ALL_USERS, UPDATE_CUSTOMER_APPROVER, LOGOUT, ADD_USER, EDIT_USER, DELETE_USER, DELETE_CUSTOMER } from '../actions.type'
import { SET_ASSOCIATED_APPROVERS, SET_ALL_USERS } from '../mutations.type'
import ManagementService from '@/services/ManagementService'


const state = {
    users: [],
    userData: {},
    customers: [],
    customerData: {},
    submit: ''
}

const getters = {
    users: state => state.users.map(id => state.userData[id]),
    customers: state => state.customers.map(id => state.customerData[id])
}

const actions = {
    [GET_ASSOCIATED_APPROVERS]: ({ commit }) => {
        return new Promise((resolve, reject) => {
            ManagementService.getAssociatedApprovers()
                .then(response => {
                    if (response.data) {
                        if (response.data.error) {
                            reject(response.data.error)
                        } else if (response.data.data) {
                            commit(SET_ASSOCIATED_APPROVERS, response.data.data)
                            resolve()
                        } else {
                            reject('NO DATA')
                        }
                    } else {
                        reject('NO RESPONSE')
                    }
                })
                .catch(err => {
                    if (err && err.response && err.response.status === 403) {
                        commit(LOGOUT);
                        this.$router.replace('/login');
                    }
                    reject(err)
                })
        })
    },
    [GET_ALL_USERS]: ({ commit }) => {
        return new Promise((resolve, reject) => {
            ManagementService.getAllUsers()
                .then(response => {
                    if (response.data) {
                        if (response.data.error) {
                            if (response.data.error.status) {
                                if (response.data.error.status == 403) {
                                    commit(LOGOUT);
                                    this.$router.replace('/login')
                                }
                            }
                            reject(response.data.error)
                        } else if (response.data.data) {
                            commit(SET_ALL_USERS, response.data.data)
                            resolve()
                        } else {
                            reject('NO DATA')
                        }
                    } else {
                        reject('NO RESPONSE')
                    }
                })
                .catch(err => {
                    if (err && err.response && err.response.status === 403) {
                        commit(LOGOUT);
                        this.$router.replace('/login');
                    }
                    reject(err)
                })
        })
    },
    [UPDATE_CUSTOMER_APPROVER]: ({ commit }, { customerId, userId }) => {
        return new Promise((resolve, reject) => {
            ManagementService.updateCustomerApprover(customerId, userId)
                .then(resp => {
                    if (resp.data) {
                        if (resp.data.error) {
                            reject(resp.data.error)
                        } else if (resp.data.data) {
                            resolve()
                        }
                        else {
                            reject('NO DATA')
                        }
                    }
                    else {
                        reject('NO RESPONSE')
                        commit()
                    }
                })
                .catch(err => {
                    if (err && err.response && err.response.status === 403) {
                        window.alert('You are not authorized to perform this action')
                    }
                    reject(err)
                })
        })
    },
    [ADD_USER]: ({ commit }, { name, email }) => {
        return new Promise((resolve, reject) => {
            ManagementService.addUser(name, email)
                .then(resp => {
                    if (resp.data) {
                        if (resp.data.error) {
                            reject(resp.data.error)
                        } else if (resp.data.data) {
                            resolve()
                        }
                        else {
                            reject('NO DATA')
                        }
                    }
                    else {
                        reject('NO RESPONSE')
                    }
                })
                .catch(err => {
                    if (err && err.response && err.response.status === 403) {
                        commit(LOGOUT);
                        this.$router.replace('/login');
                    }
                    reject(err)
                })
        })
    },
    [EDIT_USER]: ({ commit }, { name, email, user_id }) => {
        return new Promise((resolve, reject) => {
            ManagementService.editUser(name, email, user_id)
                .then(resp => {
                    if (resp.data) {
                        if (resp.data.error) {
                            reject(resp.data.error)
                        } else if (resp.data.data) {
                            resolve()
                        }
                        else {
                            reject('NO DATA')
                        }
                    }
                    else {
                        reject('NO RESPONSE')
                    }
                })
                .catch(err => {
                    if (err && err.response && err.response.status === 403) {
                        commit(LOGOUT);
                        this.$router.replace('/login');
                    }
                    reject(err)
                })
        })
    },
    [DELETE_USER]: ({ commit }, { email }) => {
        return new Promise((resolve, reject) => {
            ManagementService.deleteUser(email)
                .then(resp => {
                    if (resp.data) {
                        if (resp.data.error) {
                            reject(resp.data.error)
                        } else if (resp.data.data) {
                            resolve()
                        }
                        else {
                            reject('NO DATA')
                        }
                    }
                    else {
                        reject('NO RESPONSE')
                    }
                })
                .catch(err => {
                    if (err && err.response && err.response.status === 403) {
                        commit(LOGOUT);
                        this.$router.replace('/login');
                    }
                    reject(err)
                })
        })
    },
    [DELETE_CUSTOMER]: ({ commit }, { customerId }) => {
        return new Promise((resolve, reject) => {
            ManagementService.deleteCustomer(customerId)
                .then(resp => {
                    if (!resp.error) {
                            resolve()
                        }
                        else {
                            reject('NO DATA')
                        }
                    })
                .catch(err => {
                    if (err && err.response && err.response.status === 403) {
                        commit(LOGOUT);
                        this.$router.replace('/login');
                    }
                    reject(err)
                })
        })
    }
}

// basic mutations, showing loading, success, error to reflect the api call status and the token when loaded
const mutations = {
    [SET_ASSOCIATED_APPROVERS]: (state, data) => {
        state.customerData = {}
        data.forEach(customer => {
            state.customerData[customer.customer_id] = customer
        });
        state.customers = Object.keys(state.customerData)
    },
    [SET_ALL_USERS]: (state, data) => {
        state.userData = {}
        data.forEach(user => {
            state.userData[user.id] = user
        });
        state.users = Object.keys(state.userData)
    }
}

export default {
    state,
    getters,
    actions,
    mutations
}
